import React from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';

import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import FooterContactUs from './components/footer/FooterContactUs';
import OfferForTheMachineYouAreLookingFor from './components/OfferForTheMachineYouAreLookingFor';

const ExpertiseAndValuation = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('expertiseAndValuation'),
      url: '/content/expertise-and-valuation',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Ekspertiz ve Değerleme</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Ekpertiz raporları iki ana kısımdan oluşmaktadır. İlki; satılması planlanan makinanın genellikle Türkiye temsilcisi tarafından yapılan bağımsız ekpertiz incelemesidir.
                  Eğer iyiMakina.com'da makinanızı satmak isteriyorsanız, satmak istediğiniz makinanın temsilcisi tarafından ekspertiz raporunu almanız gerekmektedir.
                </p>
                <p>
                  İkinci ise iyiMakina'nın uzman ekibi tarafından kayda alınan genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videoyu kapsayan çalışmadır.
                  Makinanın kategorisine ve modeline göre yapılan bu destekleyici çalışma için satıcıdan ücret tahsil edilmemektedir.
                </p>
                <p>
                  iyiMakina.com’un uzman ekibi aklınıza takılabilecek tüm sorulara cevap verebilmeniz için görsel olarak eksiksiz bir rapor oluşturmayı ve
                  satışı planlanan makinanın Türkiye temsilci firma tarafından yapılan tetkiklerle beraber, oldukça güvenilir bir rapor ortaya çıkarmayı hedefler.
                </p>
                <p>
                  Platformumuzda satışa çıkan tüm makinalar, detaylı olarak incelenmiş ekpertiz raporunu içerir.
                  Ekspertiz raporu bulunmayan makinalar, iyiMakina.com'da satışa çıkarılmamaktadır.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Ücretsiz İnceleyin</h2>
              </div>
              <div className="col-15">
                <p>
                  Satışa çıkan makinaların detaylı ekspertiz raporları, makinanın ilan sayfasında yer almaktadır.
                  Ekspertiz raporu, detaylı görsel ve videoları ücretsiz olarak inceleyebilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Uzman Ekip</h2>
              </div>
              <div className="col-15">
                <p>
                  Alanında uzman ekibimiz makinaları yerinde inceleyerek, kapsamlı bir ekspertiz raporu sunar.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Detaylı Rapor</h2>
              </div>
              <div className="col-15">
                <p>
                  Makinanın genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videosunu kapsayan çalışmadır.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Sektör Tecrübesi</h2>
              </div>
              <div className="col-15">
                <p>
                  45 yıllık tecrübemizle en iyi bildiğimiz işi yapıyoruz.
                  Hem alıcılar hem de satıcılar için güvenli ve adil bir alım-satım süreci önceliğimiz.
                </p>
              </div>
            </div>
            <OfferForTheMachineYouAreLookingFor />
            <FooterContactUs about="Ekspertiz ve Değerleme ile" />
          </div>
        </div>
      </div>
    </main>
  );
};

ExpertiseAndValuation.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Ekspertiz ve Değerleme',
    },
  };
};

ExpertiseAndValuation.Layout = Layout;

export default withTranslation('common')(ExpertiseAndValuation);
